module.exports = __webpack_public_path__ + "img/musk.fabbee93.jpg";